import * as Yup from "yup";
import PatientPersonalInfoValidation from "./patientPersonalInfo.validation";
import PatientContactInfoValidation from "./patientContactInfo.validation";
import PatientSecurityInfoValidation from "./patientSecurityInfo.validation";

const PatientInformationValidation = Yup.object()
  .concat(PatientPersonalInfoValidation)
  .concat(PatientContactInfoValidation)
  .concat(PatientSecurityInfoValidation);

export default PatientInformationValidation;
